import { useTranslation } from 'react-i18next';
import { ChartNoAxesCombined } from 'lucide-react';
import ComingSoonPanel from '../components/ComingSoonPanel';

const ApiUsage = () => {
  const { t } = useTranslation('settings');

  return (
    <ComingSoonPanel
      title={t('apiUsage.title')}
      description={t('apiUsage.comingSoon')}
      notice={t('apiUsage.availabilityNotice')}
      icon={ChartNoAxesCombined}
    />
  );
};

export default ApiUsage;
